import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import Button from '@mui/material/Button';
import LandscapeIcon from '@mui/icons-material/Landscape';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { returnFilterText, statusLabel } from '../Utils.js';

function SearchCard({data, onClick}) {

  let category = data.category.trim.length > 0 ? data.category.split(",") : "";
  let statustagelm = data.status ? statusLabel(data.status, "card"): null;

  return (
    <div className="searchcard" data-id={data.id}>
      <Card sx={{ maxWidth: 345 }}  onClick={onClick} key={data.id} data-id={data.id}>
        <CardActionArea>
          {data.coverimage ?
            (<CardMedia
              component="img"
              height="140"
              image={data.coverimage}
              alt={data.group}
              className={"defualtImage " + data.status}
            />)
            : <div className='defualtImage'><LandscapeIcon /></div>
          }
          <div className='statustagWrapper'>{statustagelm}</div>

          <CardContent>
            <Typography gutterBottom variant="h6" component="div">{data.group}</Typography>
            {category.length > 0 ? data.category.map((x, i) => (<Button variant="contained" key={i} size="small">x</Button>)) : ""}
            <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" flexWrap="wrap" >
              {/* {statusLabel(data.status)} */}
              {data.category && data.category.split(", ").map(x => (<Chip variant="outlined" size="small" sx={{fontSize: '0.75rem' }} key={x} label={returnFilterText("category", x)} />))}
            </Stack>
          </CardContent>
        </CardActionArea>
      </Card>

    </div>
  );
}


export default SearchCard;
